import React, {useEffect, useState} from 'react';
import {Button, Col, ConfigProvider, DatePicker, DatePickerProps, Form, Input, Modal, Row} from 'antd';
import Colors from "../../../styles/Colors";
import {BiCheck, BiX} from "react-icons/bi";
import 'dayjs/locale/es';
import locale from "antd/es/locale/es_ES";
import dayjs from "dayjs";
import {Escola} from "../../../model/root/Escola";
import {GetInscripcionsEscoles} from "../../../dao/inscripcions/GetInscripcionsEscoles";
import {PostInscripcioInfant} from "../../../dao/inscripcions/PostInscripcioInfant";
import {useParams} from "react-router-dom";

interface PagadorModalProps {
    element: any; // Cambiado a tipo any para aceptar cualquier tipo de elemento
    visible: boolean;
    page: string,
    onClose: (valor: boolean) => void;
}

const InfantsModal: React.FC<PagadorModalProps> = ({element, visible, onClose, page}) => {
    const [form] = Form.useForm();
    const [escoles, setEscoles] = useState<Escola[]>([]);

    const {id_inscripcio} = useParams();

    useEffect(() => {
        checkOptions();
    }, []);

    async function checkOptions() {
        const esc = await GetInscripcionsEscoles(page);
        setEscoles(esc);
    }

    async function handleSubmit() {
        const formData = form.getFieldsValue();
        const newData = {...formData, data_naix: formData.data_naix2};
        ////console.log("Form Data:", newData);
        await PostInscripcioInfant(newData, id_inscripcio !== undefined ? id_inscripcio : element.id_inscripcio + "", page);
        onClose(true);
    }

    const handleCancel = () => {
        onClose(true);
    };


    const dateFormatEs = 'DD-MM-YYYY';

    const customWeekStartEndFormatDayA: DatePickerProps['format'] = (value) =>
        `${dayjs(value).format(dateFormatEs)}`;

    return (
        <ConfigProvider locale={locale}>
        <Modal
            title="INSCRIPCIÓ"
            visible={visible}
            onCancel={handleCancel}
            footer={[]}
            maskClosable={false}
            width={"40%"}
        >
            <Form form={form} initialValues={element} onFinish={handleSubmit}>
                <Row gutter={[16, 16]}>
                    <Col span={24}>
                        <Form.Item label="ID" name="id">
                            <Input disabled/>
                        </Form.Item>
                        <Form.Item label="Nom Infant" name="nom"
                                   rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                            <Input/>
                        </Form.Item>
                        <Form.Item label="Cognoms Infant" name="cognoms"
                                   rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                            <Input/>
                        </Form.Item>
                        <Form.Item label="Data naixement" name="data_naix2"
                                   rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                            <DatePicker
                                value={dayjs()}
                                picker={"date"}
                                format={customWeekStartEndFormatDayA}
                            />
                        </Form.Item>
                    </Col>
                </Row>
                <Form.Item wrapperCol={{offset: 0, span: 16}}>
                    <Button title={"Aceptar"} htmlType={"submit"} style={{backgroundColor: Colors.colors.color6}}
                    ><BiCheck/></Button>
                    {" "}
                    <Button title={"Cancelar"} style={{backgroundColor: Colors.colors.color1}}
                            onClick={handleCancel}><BiX/></Button>
                </Form.Item>
            </Form>
        </Modal>
        </ConfigProvider>
    );
};

export default InfantsModal;
